<div class="lp-search-products-input">
  <tui-multi-select
    [rows]="3"
    [tuiTextfieldSize]="textfieldSize"
    [stringify]="stringify"
    [identityMatcher]="matcher"
    [tuiTextfieldCleaner]="true"
    [(ngModel)]="value"
    [disabled]="disabled"
    [pseudoInvalid]="touched && invalid"
    [editable]="false"
  >
    {{ title }}

    <ng-container *tuiDataList>
      <app-search class="search" (searchQueryChange)="search($event)"></app-search>

      <tui-data-list [size]="'l'">
        <tui-opt-group tuiMultiSelectGroup label="Выбрать все">
          <button *ngFor="let item of items$ | async" tuiOption [value]="item">
            <product-row-item [product]="item"></product-row-item>
          </button>
        </tui-opt-group>
      </tui-data-list>
    </ng-container>
  </tui-multi-select>
</div>
